import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": "50%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5 mx-4"
  }, [_vm._v("List of duplicates")])]), _c(VCardText, [_c("ul", _vm._l(_vm.wines, function (wine) {
    return _c("li", {
      key: wine.id_wine
    }, [_c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: _vm.productDetails(wine),
        target: "_blank"
      }
    }, [_c("WineNaming", {
      key: "wine-naming-".concat(wine.id_wine),
      attrs: {
        wineNamingData: wine.naming_data,
        isPrefixWinery: true,
        isSuffixBottling: true,
        isSuffixType: true
      }
    }), _vm._v(" - " + _vm._s(wine.sku) + " ")], 1)], 1);
  }), 0)])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };